module.exports = __webpack_public_path__ + "static/img/DreamStation-BiPAP.48168f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/escrowImg/DreamStation-BiPAP.jpg
// module id = iAuP
// module chunks = 1